import { formatDistanceToNowStrict } from 'date-fns';

const compactUsd = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
  style: 'currency',
  currency: 'USD',
});

const compactNumber = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1,
});

export function pctFromProb(value: number) {
  return `${Math.round(value * 100)}%`;
}

export function pp(value: number, signed = true) {
  const sign = signed && value > 0 ? '+' : '';
  return `${sign}${value.toFixed(Math.abs(value) < 10 ? 1 : 0)}pp`;
}

export function money(value: number) {
  if (!Number.isFinite(value)) return '$0';
  return compactUsd.format(value);
}

export function count(value: number) {
  return compactNumber.format(value);
}

export function spreadPct(value: number) {
  return `${(value * 100).toFixed(value < 0.02 ? 1 : 1)}%`;
}

export function relativeTime(value?: string | Date | null) {
  if (!value) return 'waiting';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return 'waiting';
  return `${formatDistanceToNowStrict(date, { addSuffix: true })}`;
}

export function timeLabel(value: string | Date) {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
